import { useFormik } from "formik";
import { IStudentProfileFormFields, StudentProfileFormProps } from "./StudentProfileForm.interfaces";
import * as yup from 'yup';
import { useToast } from "@netfront/ekardo-content-library";
import { IUser, useUpdateUserAsAdmin } from "@netfront/gelada-identity-library";
import { useEffect, useState } from "react";
import { Button, Input } from "@netfront/ui-library";
import { useGetUser } from "@/hooks";

export const StudentProfileForm = ({ groupId, userId, onCompleted }: StudentProfileFormProps) => {
  const { handleToastSuccess, handleToastError } = useToast();

  const [user, setUser] = useState<IUser>();

  const { handleGetUser } = useGetUser({
    onCompleted: ({ user: returnedUser }) => {
      setUser(returnedUser);
    },
    onError: (error) => {
      handleToastError({
        error,
        shouldUseFriendlyErrorMessage: true,
      });
    },
  });

  const { handleUpdateUserAsAdmin } = useUpdateUserAsAdmin({
    onCompleted: () => {
      if(onCompleted) {
        onCompleted(user as IUser);
      }
      handleToastSuccess({
        message: 'Profile updated successfully',
      });
    }
  })

  const formik = useFormik<IStudentProfileFormFields>({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
    validationSchema: yup.object().shape({
      firstName: yup.string().required('Please enter in a first name'),
      lastName: yup.string().required('Please enter in a last name'),
      email: yup.string().email().required('Please enter in an email address'),
    }),
    onSubmit: async ({ email, firstName, lastName }: IStudentProfileFormFields) => {
      setUser({
        ...user,
        credential: {
          ...user?.credential,
          email
        },
        firstName,
        lastName
      } as IUser);

      handleUpdateUserAsAdmin({
        userId,
        email,
        firstName,
        lastName
      });
    }
  });

  useEffect(() => {
    if(!userId || !groupId) return;

    handleGetUser({
      groupId,
      userId
    });

  }, [userId]);

  useEffect(() => {
    if(!user) return;

    setFieldValue('firstName', user.firstName);
    setFieldValue('lastName', user.lastName);
    setFieldValue('email', user.credential.email);

  }, [user]);

  const { errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, values } = formik;

  return(
    <form onSubmit={handleSubmit}>
      <Input
        additionalClassNames="!m-0"
        errorMessage={touched.firstName && errors.firstName ? errors.firstName : ''}
        id='firstName'
        labelText='First name'
        placeholder='Enter first name'
        name='firstName'
        onChange={handleChange}
        type='text'
        value={values.firstName}
        onBlur={handleBlur}
        isRequired
      />

      <Input
        errorMessage={touched.lastName && errors.lastName ? errors.lastName : ''}
        id='lastName'
        labelText='Last name'
        placeholder='Enter last name'
        name='lastName'
        onChange={handleChange}
        type='text'
        value={values.lastName}
        onBlur={handleBlur}
        isRequired
      />

      <Input
        errorMessage={touched.email && errors.email ? errors.email : ''}
        id='email'
        labelText='Email'
        placeholder='Enter email'
        name='email'
        onChange={handleChange}
        type='email'
        value={values.email}
        onBlur={handleBlur}
      />

      <Button
        additionalClassNames='mt-6'
        text='Update details'
        type='submit'
        // isLoading={isFormSubmitting}
      />
    </form>

  )
};